import { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Button, Modal, CloseButton } from "react-bootstrap";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import '../styles/MenuRespond.css'
import axios from 'axios';

if (typeof window !== 'undefined' && window.location.search) {
    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, '', cleanUrl);
}

export default function SingleRequest() {
    // const [stringTitle, setTitle] = useState("");
    const navigate = useNavigate();
    const handleNavigation = (path) => {
        navigate(path);
    };

    const [userId, setUserId] = useState('');
    const [userName, setUserName] = useState('');
    const userIdRef = useRef('');
    const userNameRef = useRef('');
    const hasRunRef = useRef(false); 

    const [file, setFile] = useState(null);
    const [remarksData, setRemarksData] = useState({
        reason: '',
        remarks: '',
    });

    const formatToSQLDateTime = (isoDateTime) => {
        const date = new Date(isoDateTime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit format
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = "00"; // Manually set seconds to match SQL format
    
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const getLocalDateTime = () => {
        const now = new Date();
        // Add 8 hours (UTC+8)
        now.setHours(now.getHours() + 8);
        // Format to ISO 8601 (YYYY-MM-DDTHH:mm) for datetime-local
        return now.toISOString().slice(0, 16);
    };

    const [releaseDate, setReleaseDate] = useState(getLocalDateTime());
    const [currentDateTime, setCurrentDateTime] = useState(getLocalDateTime());
    const [displayData, setDisplayData] = useState([{
        receiver_name: '',
        receive_date: '',
        claimed_by: '',
      }]);
    const [displayPortrait, setDisplayPortrait] = useState('');

    const [displayReceipt, setDisplayReceipt] = useState('');
    const [displayDocument, setDisplayDocument] = useState('');

    const [currentStatusIndex, setCurrentStatusIndex] = useState(0);
    const [confirmResolve, setConfirmResolve] = useState(null);


    const [isExceedOpen, setIsExceedOpen] = useState(false);
    const [exceedParams, setExceedParams] = useState({
        exceed_fee: '',   
        exceed_pages: '',  
        exceed_total : ''
    });
    const [confirmParams, setConfirmParams] = useState({});
    const [contactParams, setContactParams] = useState({});
    const [modalConfirm, setModalConfirm] = useState(false);
    const [modalContactCourier, setModalContactCourier] = useState(false);
    const [modalRelease, setModalRelease] = useState(false);
    const [modalReject, setModalReject] = useState(false);
    const [modalReceipt, setModalReceipt] = useState(false);
    const [isActionsOpen, handleActions] = useState(false);
    const toggleActions = () => { handleActions((prev) => !prev); };

    const [isEditing, setIsEditing] = useState(false);
    const [editData, setEditData] = useState({
    requestor_name: '',
    requestor_phone: '',
    requestor_email: '',
    owner_firstname: '',
    owner_middlename: '',
    owner_lastname: '',
    owner_phone: '',
    owner_SWU: '',
    owner_course: '',
    owner_course_year: '',
    owner_year_last: '',
    delivery_region: '',
    delivery_city: '',
    delivery_district: '',
    delivery_street: ''
    });

    useEffect(() => {
    if (displayData.length > 0) {
        setEditData({
        requestor_name: displayData[0].requestor_name || '',
        requestor_phone: displayData[0].requestor_phone || '',
        requestor_email: displayData[0].requestor_email || '',
        owner_firstname: displayData[0].owner_firstname || '',
        owner_middlename: displayData[0].owner_middlename || '',
        owner_lastname: displayData[0].owner_lastname || '',
        owner_phone: displayData[0].owner_phone || '',
        owner_SWU: displayData[0].owner_SWU || '',
        owner_course: displayData[0].owner_course || '',
        owner_course_year: displayData[0].owner_course_year || '',
        owner_year_last: displayData[0].owner_year_last || '',
        delivery_region: displayData[0].region || '',
        delivery_city: displayData[0].delivery_city || '',
        delivery_district: displayData[0].delivery_district || '',
        delivery_street: displayData[0].delivery_street || ''
        });
    }
    }, [displayData]);

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditData(prev => ({
          ...prev,
          [name]: value
        }));
    };

    const handleSaveEdits = async (e) => {
        e.preventDefault();
        
        try {

            const patchData = {
                // Required fields
                owner_lastname: editData.owner_lastname,
                
                // Requestor info
                requestor_name: editData.requestor_name,
                requestor_phone: editData.requestor_phone,
                requestor_email: editData.requestor_email,
                
                // Owner info
                owner_firstname: editData.owner_firstname,
                owner_phone: editData.owner_phone,
                
                // Academic info
                owner_course: editData.owner_course,
                owner_course_year: editData.owner_course_year,
                owner_year_last: editData.owner_year_last,
                
                // Optional fields
                ...(editData.owner_middlename && { owner_middlename: editData.owner_middlename }),
                ...(editData.owner_SWU && { owner_SWU: editData.owner_SWU }),
                
                // System fields
                staff: userIdRef.current
            };

            const response = await axios.patch(
                `http://localhost:80/api_drts/transactions.php/${displayData[0].reference}`,
                patchData,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.data.status === 1) {
                // Update local state
                setDisplayData(prev => prev.map(item => ({
                    ...item,
                    requestor_name: editData.requestor_name,
                    requestor_phone: editData.requestor_phone,
                    requestor_email: editData.requestor_email,
                    owner_firstname: editData.owner_firstname,
                    owner_lastname: editData.owner_lastname,
                    owner_phone: editData.owner_phone,
                    owner_course: editData.owner_course,
                    owner_course_year: editData.owner_course_year,
                    owner_year_last: editData.owner_year_last,
                    ...(editData.owner_middlename && { owner_middlename: editData.owner_middlename }),
                    ...(editData.owner_SWU && { owner_SWU: editData.owner_SWU }),
                    updated_at: new Date().toISOString()
                })));
                
                setIsEditing(false);
                alert("Details updated successfully!");
                setRefreshing(true);
            } else {
                throw new Error(response.data.message || "Update failed");
            }
        } catch (err) {
            console.error("Update error:", {
                error: err,
                response: err.response?.data
            });
            alert(`Update failed: ${err.response?.data?.message || err.message}`);
        }
    };

    // Open the action confirmation modal and return a Promise
    const showConfirm = async (params) => {
        // console.log("showConfirm called:", params);
        return new Promise((resolve) => {
            setConfirmParams(params);
            setConfirmResolve(() => resolve);
            setModalConfirm(true);
        });
    };
    
    // Handle confirm modal confirm action
    const handleConfirm = async (e) => {
        e.preventDefault();
        // console.log("Running handleConfirm!");
    
        if (confirmParams?.action) {
            //console.log("Executing action...");
            await confirmParams.action(e);
        }
    
        if (confirmResolve) {
            confirmResolve(true);
        }
        setModalConfirm(false);
        // console.log("Action completed.");
    };
    
    // Handle confirm modal cancel action
    const handleCancel = () => {
        setModalConfirm(false);
        setConfirmParams({});
        if (confirmResolve) {
            confirmResolve(false); // Resolve the Promise with `false`
        }
    };

    // save refNumber and lastname on first load
    var { refNumber } = useParams() || localStorage.getItem("refNumber");
    const location = useLocation();
    const lastname = location.state?.lastname || localStorage.getItem("lastname");
    
    useEffect(() => {
        //alert(`localStorage refNumber: ${refNumber}`);
        //alert(`localStorage lastname: ${lastname}`);
        
        localStorage.setItem("refNumber", String(refNumber));
        localStorage.setItem("lastname", String(lastname));
    }, [refNumber, lastname])

    useEffect(() => {
        // prevent URL from showing params on refresh
        if (window.location.search) {
          const cleanUrl = window.location.origin + window.location.pathname;
          window.history.replaceState({}, '', cleanUrl);
        }

        // reset refNumber and lastname on unmount of SingleRequest.js
        return () => {
            localStorage.removeItem("refNumber");
            localStorage.removeItem("lastname");
        };
    }, []);
      

    const [regionFee, setRegionFee] = useState(null);
    const [isFeeLoading, setIsFeeLoading] = useState(false); 
    const [loading, setLoading] = useState(true);
    const [refreshing, setRefreshing] = useState(false);
    const [error, setError] = useState(null);
    //const INT_refNumber = parseInt(refNumber, 10);
    
    // const URI_array = window.location.href.split("/");
    // const found_word = URI_array[3];

    const [modalDeliver, setModalDeliver] = useState(false);
    const [deliverData, setDeliverData] = useState({
    receiver_name: '',
    receive_date: getLocalDateTime()
    });
    const [modalClaim, setModalClaim] = useState(false);
    const [claimData, setClaimData] = useState({
        receiver_name: '',
        receive_date: getLocalDateTime()
    });

useEffect(() => {
    if (displayData.length > 0 && displayData[0]?.status_transit === "Claimed") {
        axios.get(`https://docuquest-swu.swucite.tech/api_drts/transactionsClaim.php`, {
            params: {
                ref: displayData[0].reference,
                lastname: displayData[0].owner_lastname
            }
        })
        .then(response => {
            if (response.data.status === 1 && response.data.data) {
                setDisplayData(prev => prev.map(item => ({
                    ...item,
                    receiver_name: response.data.data.receiver_name,
                    receive_date: response.data.data.receive_date,
                    claimed_by: response.data.data.claimed_by
                })));
            }
        })
        .catch(err => {
            //console.error("Error fetching claim data:", err);
        });
    }
}, [displayData]);

const handleDeliverChange = (e) => {
    const { name, value } = e.target;
    setDeliverData(prev => ({
      ...prev,
      [name]: value
    }));
};

const handleDeliverSubmit = async (e) => {
    e.preventDefault();
    
    // Prepare the delivery data add this HANS
    const deliverPayload = {
      reference: displayData[0].reference,
      owner_lastname: displayData[0].owner_lastname,
      receiver_name: deliverData.receiver_name,
      receive_date: deliverData.receive_date,
      staff: userIdRef.current,
      action: "Deliver"
    };
  
    //console.log("Submitting delivery data:", deliverPayload);
  
    try {
      const response = await axios.post(
        'https://docuquest-swu.swucite.tech/api_drts/transactionsClaim.php',
        deliverPayload
      );
  
      if (response.data.status === 1) {
        // Update local state
        setDisplayData(prev => prev.map(item => ({
          ...item,
          status_transit: "Delivered",
          receiver_name: deliverData.receiver_name,
          receive_date: deliverData.receive_date,
          claimed_by: userIdRef.current
        })));
        
        setModalDeliver(false);
        alert("Delivery recorded successfully!");
        

        const reference = displayData[0].reference;
        const workflowResponse = await axios.get(`https://docuquest-swu.swucite.tech/api_drts/workflow.php?ref=${reference}`);
        const existingEntry = workflowResponse.data;

        const storedValues = existingEntry.data[0];
        const today = new Date();

        const updatedScoreEff = parseFloat(storedValues.score_eff) + 0.5;
        const updatedScoreProd = parseFloat(storedValues.score_prod) + 1.8;
        
        // Add to workflow
        const workflowData = {
            updated_by: userIdRef.current,
            updated_date: formatToSQLDateTime(today),
            created_by: storedValues.created_by,
            created_date: storedValues.created_date,
            ref: reference,
            feedback: `Document received by ${claimData.receiver_name}`,
            name_action: "Document Deliver",
            status_action: `Document received by ${claimData.receiver_name}`,
            stage_now: 5,
            stage_max: 5,
            score_eff: updatedScoreEff,
            score_prod: updatedScoreProd
        };
        
        await axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, workflowData);
        
      } else {
        throw new Error(response.data.message || "Failed to record delivery");
      }

      setRefreshing(true);
    } catch (err) {
      //console.error("Error recording delivery:", err);
      alert(err.message || "Failed to record delivery");
    }
};


const handleClaimChange = (e) => {
    const { name, value } = e.target;
    setClaimData(prev => ({
        ...prev,
        [name]: value
    }));
};

const handleClaimSubmit = async (e) => {
    e.preventDefault();
    
    // Prepare the claim data
    const claimPayload = {
        reference: displayData[0].reference,
        owner_lastname: displayData[0].owner_lastname,
        receiver_name: claimData.receiver_name,
        receive_date: claimData.receive_date,
        staff: userIdRef.current,
        action: "Document Claim"
    };

    //console.log("Submitting claim data:", claimPayload);

    try {
        const response = await axios.post(
            'https://docuquest-swu.swucite.tech/api_drts/transactionsClaim.php',
            claimPayload,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }
        );

        if (response.data.status === 1) {
            // Update local state
            setDisplayData(prev => prev.map(item => ({
                ...item,
                status_transit: "Claimed",
                receiver_name: claimData.receiver_name,
                receive_date: claimData.receive_date,
                claimed_by: userIdRef.current
            })));
            
            setModalClaim(false);
            // alert("Claim recorded successfully!");
            
            const reference = displayData[0].reference;
            const workflowResponse = await axios.get(`https://docuquest-swu.swucite.tech/api_drts/workflow.php?ref=${reference}`);
            const existingEntry = workflowResponse.data;

            const storedValues = existingEntry.data[0];
            const today = new Date();

            const updatedScoreEff = parseFloat(storedValues.score_eff) + 0.5;
            const updatedScoreProd = parseFloat(storedValues.score_prod) + 1.8;

            // Add to workflow
            const claimWorkflow = {
                updated_by: userIdRef.current,
                updated_date: formatToSQLDateTime(today),
                created_by: storedValues.created_by,
                created_date: storedValues.created_date,
                ref: reference,
                feedback: `Document claimed by ${claimData.receiver_name}`,
                name_action: "Document Claim",
                status_action: `Document claimed by ${claimData.receiver_name}`,
                stage_now: 5,
                stage_max: 5,
                score_eff: updatedScoreEff,
                score_prod: updatedScoreProd
            };
                
            await axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, claimWorkflow);
            
        } else {
            throw new Error(response.data.message || "Failed to record claim");
        }

        setRefreshing(true);
    } catch (err) {
        //console.error("Error recording claim:", err);
        //alert(err.message || "Failed to record claim");
    }
};
    
    // translate user statuses into admin statuses refer to sheet 2
    const convertStatusTransit = (statusTransitRequest) => {
        switch (statusTransitRequest) {
          case "Request Placed":
              return "Archiving"; 
          case "In Review":
              return "In Review";
          case "Payment Sent":
              return "Processing";
          case "Accepted":
              return "Accepted";
          case "Rejected":
              return "Rejected";       
          case "Processing":
              return "Processing";                   
          case "Done":
              return "Completed"; 
          case "Completed":
              return "Completed"; 
          case "Ready to Pick Up":
              return "Out for Delivery/For releasing";
          case "For Releasing":
              return "Out for Delivery/For releasing";
          case "Out for Delivery":
              return "Out for Delivery/For releasing";
          case "Received":
              return "Document claimed";
          case "Claimed":
              return "Document claimed";
          default:
              //console.error("INVALID transit status");
              //console.warn("redirected to Archiving");
              return "Archiving"; // Default stage if no matches
        }
    };

    const convertStatusPayment = (statusPaymentRequest) => {
        switch (statusPaymentRequest) {
            case "Not Paid":
              return "Waiting for payment";
            case "Paid":
              return "Payment received";
            default:
              //console.error("INVALID payment status");
              //console.warn("redirected to Waiting for payment");
              return "";        
        }
    }
    
    // keep time in sync
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentDateTime(getLocalDateTime()); // Update time every second
            // console.log("time now: ", getLocalDateTime());
        }, 1000);
    
        return () => clearInterval(interval); // Cleanup to prevent memory leaks
    }, []); // Runs only once on component mount

    const fetchTransactionDetails = async () => {
        try {
            document.title = "Respond to Transaction";
            setLoading(true);
            setRefreshing(false);

            const sessionRes = await axios.post(
                'https://docuquest-swu.swucite.tech/api_drts/checkSession.php',
                {},
                { withCredentials: true }
            );

            //console.warn("test session check");
            //alert(JSON.stringify(sessionRes.data, null, 2))

            if (sessionRes.data.status === 1) {
                userIdRef.current = sessionRes.data.id;
                userNameRef.current = sessionRes.data.fullname;
                setUserId(sessionRes.data.id);
                setUserName(sessionRes.data.fullname);
            }

            const txRes = await axios.get(
                `https://docuquest-swu.swucite.tech/api_drts/transactionsOwner.php/${refNumber}`,
                { params: { trackingName: lastname } }
            );

            //console.warn("txRes: ", txRes)
            //console.table(txRes.data);

            const formattedData = txRes.data.map((r) => ({
                request_id: r.id,
                reference: r.reference_number,
                file_receipt: r.file_receipt ? r.file_receipt : "",
                file_portrait: r.file_portrait ? r.file_portrait : "",
                service: r.service_type,
                total_price: r.price_total,
                payment_channel: r.payment_channel,
                region: r.delivery_region || "",
                delivery_city: r.delivery_city || "",
                delivery_district: r.delivery_district || "",
                delivery_street: r.delivery_street || "",
                requestor_address: `${r.delivery_street || ''}, ${r.delivery_district || ''}, ${r.delivery_city || ''}, ${r.delivery_region || ''}`
                .replace(/, ,/g, ',')
                .replace(/^, |, $/g, ''),
                selected_docs: r.selected_docs ? JSON.parse(r.selected_docs) : [],
                doc_id: r.id_doc,
                doc_type: r.doc_name || "N/A",
                doc_quantity: r.doc_quantity,
                doc_price: r.price,
                requested_at: r.created_at,
                updated_at: r.updated_at,
                released_at: r.released_at,
                requestor_name: r.name_req,
                requestor_phone: r.phone_req,
                requestor_email: r.email_req,
                owner_firstname: r.firstname_owner,
                owner_middlename: r.middlename_owner,
                owner_lastname: r.lastname_owner,
                owner_phone: r.phone_owner,
                owner_SWU: r.id_swu || "",
                owner_course: r.course,
                owner_course_year: r.course_year,
                owner_year_last: r.year_last,
                purpose: r.purpose_req 
                ? (Array.isArray(r.purpose_req) 
                    ? r.purpose_req.join(', ') 
                    : (() => {
                        try {
                            const parsedPurpose = JSON.parse(r.purpose_req);
                            return Array.isArray(parsedPurpose) ? parsedPurpose.join(', ') : 'Invalid Purpose';
                        } catch {
                            return 'Invalid Purpose';
                        }
                        })()
                    )
                : 'No Purpose',
                description: r.desc_req,
                status_transit: r.statusTransit,
                reason_reject: r.reason_reject,
                remarks: r.remarks,
                status_payment: r.statusPayment,
                overdue_days: r.overdue_days,
                updated_overdue: r.updated_overdue,
                supporting_docs: (() => {
                    let raw = r.supporting_docs;
                  
                    // null, empty string, and [] string are considered as no docs
                    if (raw == null || raw === "" || raw === "[]") {
                      return [];
                    }
                  
                    let uris = [];
                  
                    if (Array.isArray(raw)) {
                      uris = raw;
                    } else if (typeof raw === "string") {
                      const trimmed = raw.trim();
                  
                      if (trimmed === "[]") {
                        uris = [];
                      }
                      else if (trimmed.startsWith("[")) {
                        try {
                          const parsed = JSON.parse(trimmed);
                          if (Array.isArray(parsed)) uris = parsed;
                        } catch (e) {
                          // console.warn("Could not parse supporting_docs:", e);
                        }
                      }
                      else {
                        // any other non‑empty string
                        uris = [trimmed];
                      }
                    }
                  
                    return uris.map((uri, idx) => ({
                      uri,
                      fileType: "pdf",
                      fileName: `${r.lastname_owner}_suppdoc_${idx + 1}.pdf`
                    }));
                  })(),
            }));

            try {
                await Promise.all(
                    formattedData.map(async (row) => {
                        // console.log("Processing row:", row.reference);
                        
                        // if received, delivered, or claimed, set the overdue_days to 0 and updated_overdue to NULL
                        if (row.status_transit === "Received" || row.status_transit === "Claimed" || row.status_transit === "Delivered") {
                            row.overdue_days = 0;
                            row.updated_overdue = null;
                        }

                        const updatedStatusTransit =
                            row.status_transit === "Request Placed" ? "In Review" : row.status_transit;
    
                        const updatedStatusPayment =
                            row.file_receipt ? "Paid" : row.status_payment;
    
                        // TODO copy overdue_days logic to Transactions.js
                        if (row.released_at) {
                            const releasedAtDate = new Date(row.released_at);
                            const currentDate = new Date(formatToSQLDateTime(getLocalDateTime()));
    
                            // Calculate days overdue based on difference
                            const timeDiff = currentDate - releasedAtDate;
                            const daysOverdue = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    
                            // console.log("Release Date:", releasedAtDate, "Current Date:", currentDate, "Days Overdue:", daysOverdue);
    
                            if (daysOverdue > 0) {
                                // console.log("Fetching overdue data for reference:", row.reference);
                                // console.log(`${displayData[0].reference} is ${daysOverdue} days overdue!`)
                                // sendNotification("warning", `${displayData[0].reference} is ${daysOverdue} days overdue!`);
                                
                                const overdueResponse = await axios.get(
                                    `https://docuquest-swu.swucite.tech/api_drts/transactionsOverdue.php/${row.reference}`,
                                    { params: { lastname_owner: row.owner_lastname } }
                                );
    
                                // console.log("Overdue data received:", overdueResponse.data); // Log overdue response
    
                                let lastUpdatedOverdue = overdueResponse.data?.updated_overdue 
                                    ? new Date(overdueResponse.data.updated_overdue) 
                                    : null;
                                let currentOverdueDays = parseInt(overdueResponse.data?.overdue_days, 10) || 0;
    
                                // console.log("Last Updated Overdue:", lastUpdatedOverdue, "Current Overdue Days:", currentOverdueDays);
    
                                if ((!lastUpdatedOverdue || lastUpdatedOverdue.toDateString() < currentDate.toDateString()) &&
                                    daysOverdue > currentOverdueDays) {
                                    // console.log("Submitting overdue update:", {
                                    //     reference: row.reference,
                                    //     overdue_days: daysOverdue,  
                                    //     last_overdue_update: formatToSQLDateTime(getLocalDateTime()),
                                    // });
                                    
                                    // TODO move this to after POST to checkSession.php
                                    await axios.patch(
                                        `https://docuquest-swu.swucite.tech/api_drts/transactionsOverdue.php/${row.reference}`,
                                        {
                                            owner_lastname: row.owner_lastname,
                                            overdue_days: daysOverdue,
                                            staff: userIdRef.current,
                                            requestor_email: row.requestor_email,
                                            service: row.service,
                                            selected_docs: row.selected_docs,
                                            last_overdue_update: formatToSQLDateTime(getLocalDateTime()),
                                        }
                                    ).then((response) => {
                                        // console.log("Overdue update response:", response.data);


                                    }).catch((err) => {
                                        //console.error("Error updating overdue days:", err.response?.data || err.message);
                                    });
                                } else {
                                    //console.log("Overdue days already updated or no change needed.");
                                }
                            }
                        } else {
                            //console.error("Release date not set!");
                        }
    
                        // console.log("Submitting status updates for reference:", row.reference);
                        // console.log("Submitting lastname to TransitStatus.php ", row.owner_lastname);
                        // console.log("Submitting updatedStatusTransit to TransitStatus.php ", updatedStatusTransit);

                        await Promise.all([
            
                            axios.patch(`https://docuquest-swu.swucite.tech/api_drts/transactionsResetOverdue.php/${row.reference}`, {
                                owner_lastname: row.owner_lastname,
                                overdue_days: row.overdue_days,
                            }).then((response) => {
                                // console.log("Transit status update response:", response.data);
                            }).catch((err) => {
                                //console.error("Error updating overdue:", err.response?.data || err.message);
                            }),

                            axios.patch(`https://docuquest-swu.swucite.tech/api_drts/transactionsTransitStatus.php/${row.reference}`, {
                                owner_lastname: row.owner_lastname,
                                statusTransit: updatedStatusTransit,
                                staff: userIdRef.current,
                            }).then((response) => {
                                // console.log("Transit status update response:", response.data);
                            }).catch((err) => {
                                //console.error("Error updating transit status:", err.response?.data || err.message);
                            }),
    
                            axios.patch(`https://docuquest-swu.swucite.tech/api_drts/transactionsPaymentStatus.php/${row.reference}`, {
                                owner_lastname: row.owner_lastname,
                                statusPayment: updatedStatusPayment,
                            }).then((response) => {
                                // console.log("Payment status update response:", response.data);
                            }).catch((err) => {
                                //console.error("Error updating payment status:", err.response?.data || err.message);
                            }),
                        ]);
                    })
                );
            } catch (error) {
                //console.error("Error updating overdue statuses:", error.message);
            }

            setDisplayData(formattedData);
            setError(null);
        } catch (err) {
            setError(`Failed to fetch transaction details: ${err.message}`);
        } finally {
            setLoading(false);
        }
    }
    
    const docViewerDocuments = useMemo(() => {
        if (displayData.length === 0) return [];
      
        return displayData[0].supporting_docs || [];
    }, [displayData]);

    useEffect(() => {
        fetchTransactionDetails();
        //alert(`refreshing value = ${refreshing}`);
    }, [refreshing]);

    // old setting data
    // useEffect(() => {
    //     document.title = "Respond to Transaction";
    //     setLoading(true);
    //     setRefreshing(false);

    //     //console.log("Fetching transaction details for reference:", refNumber, "Tracking Name:", lastname);
    
    //     axios.post('https://docuquest-swu.swucite.tech/api_drts/checkSession.php', {}, { withCredentials: true })
    //     .then((res) => {
    //       // console.warn("is the session alive in singlerequest? ", res.data);
    //       if (res.data.status === 1) {
    //         setUserId(res.data.id);
    //         userIdRef.current = res.data.id;
    //         setUserName(res.data.fullname);
    //         userNameRef.current = res.data.fullname;
    //       } 
    //     })
    //     .catch((err) => {
    //       //console.error("ERROR: Your session cannot be found!", err);
  
    //     });   

    //     axios.get(`https://docuquest-swu.swucite.tech/api_drts/transactionsOwner.php/${refNumber}`, {
    //         params: { trackingName: lastname },
    //     })
    //     .then(async (res) => {
    //         console.log("Transaction data received:", res.data); // Log response data
    
    //         const request = res.data;
    
    //         const formattedData = request.map((r) => ({
    //             request_id: r.id,
    //             reference: r.reference_number,
    //             file_receipt: r.file_receipt ? r.file_receipt : "",
    //             service: r.service_type,
    //             total_price: r.price_total,
    //             payment_channel: r.payment_channel,
    //             region: r.delivery_region || "",
    //             delivery_city: r.delivery_city || "",
    //             delivery_district: r.delivery_district || "",
    //             delivery_street: r.delivery_street || "",
    //             requestor_address: `${r.delivery_street || ''}, ${r.delivery_district || ''}, ${r.delivery_city || ''}, ${r.delivery_region || ''}`
    //             .replace(/, ,/g, ',')
    //             .replace(/^, |, $/g, ''),
    //             selected_docs: r.selected_docs ? JSON.parse(r.selected_docs) : [],
    //             doc_id: r.id_doc,
    //             doc_type: r.doc_name || "N/A",
    //             doc_quantity: r.doc_quantity,
    //             doc_price: r.price,
    //             requested_at: r.created_at,
    //             updated_at: r.updated_at,
    //             released_at: r.released_at,
    //             requestor_name: r.name_req,
    //             requestor_phone: r.phone_req,
    //             requestor_email: r.email_req,
    //             owner_firstname: r.firstname_owner,
    //             owner_middlename: r.middlename_owner,
    //             owner_lastname: r.lastname_owner,
    //             owner_phone: r.phone_owner,
    //             owner_SWU: r.id_swu || "",
    //             owner_course: r.course,
    //             owner_course_year: r.course_year,
    //             owner_year_last: r.year_last,
    //             purpose: r.purpose_req 
    //             ? (Array.isArray(r.purpose_req) 
    //                 ? r.purpose_req.join(', ') 
    //                 : (() => {
    //                     try {
    //                         const parsedPurpose = JSON.parse(r.purpose_req);
    //                         return Array.isArray(parsedPurpose) ? parsedPurpose.join(', ') : 'Invalid Purpose';
    //                     } catch {
    //                         return 'Invalid Purpose';
    //                     }
    //                     })()
    //                 )
    //             : 'No Purpose',
    //             description: r.desc_req,
    //             status_transit: r.statusTransit,
    //             reason_reject: r.reason_reject,
    //             remarks: r.remarks,
    //             status_payment: r.statusPayment,
    //             overdue_days: r.overdue_days,
    //             updated_overdue: r.updated_overdue,
    //         }));
    
    //         // console.log("Formatted transaction data:", formattedData); // Log formatted data
    //         // console.table(formattedData);

    //         try {
    //             await Promise.all(
    //                 formattedData.map(async (row) => {
    //                     // console.log("Processing row:", row.reference);
                        
    //                     // if received, delivered, or claimed, set the overdue_days to 0 and updated_overdue to NULL
    //                     if (row.status_transit === "Received" || row.status_transit === "Claimed" || row.status_transit === "Delivered") {
    //                         row.overdue_days = 0;
    //                         row.updated_overdue = null;
    //                     }

    //                     const updatedStatusTransit =
    //                         row.status_transit === "Request Placed" ? "In Review" : row.status_transit;
    
    //                     const updatedStatusPayment =
    //                         row.file_receipt ? "Paid" : row.status_payment;
    
    //                     // TODO copy overdue_days logic to Transactions.js
    //                     if (row.released_at) {
    //                         const releasedAtDate = new Date(row.released_at);
    //                         const currentDate = new Date(formatToSQLDateTime(getLocalDateTime()));
    
    //                         // Calculate days overdue based on difference
    //                         const timeDiff = currentDate - releasedAtDate;
    //                         const daysOverdue = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    
    //                         // console.log("Release Date:", releasedAtDate, "Current Date:", currentDate, "Days Overdue:", daysOverdue);
    
    //                         if (daysOverdue > 0) {
    //                             // console.log("Fetching overdue data for reference:", row.reference);
    //                             // console.log(`${displayData[0].reference} is ${daysOverdue} days overdue!`)
    //                             // sendNotification("warning", `${displayData[0].reference} is ${daysOverdue} days overdue!`);
                                
    //                             const overdueResponse = await axios.get(
    //                                 `https://docuquest-swu.swucite.tech/api_drts/transactionsOverdue.php/${row.reference}`,
    //                                 { params: { lastname_owner: row.owner_lastname } }
    //                             );
    
    //                             // console.log("Overdue data received:", overdueResponse.data); // Log overdue response
    
    //                             let lastUpdatedOverdue = overdueResponse.data?.updated_overdue 
    //                                 ? new Date(overdueResponse.data.updated_overdue) 
    //                                 : null;
    //                             let currentOverdueDays = parseInt(overdueResponse.data?.overdue_days, 10) || 0;
    
    //                             // console.log("Last Updated Overdue:", lastUpdatedOverdue, "Current Overdue Days:", currentOverdueDays);
    
    //                             if ((!lastUpdatedOverdue || lastUpdatedOverdue.toDateString() < currentDate.toDateString()) &&
    //                                 daysOverdue > currentOverdueDays) {
    //                                 console.log("Submitting overdue update:", {
    //                                     reference: row.reference,
    //                                     overdue_days: daysOverdue,  
    //                                     last_overdue_update: formatToSQLDateTime(getLocalDateTime()),
    //                                 });
                                    
    //                                 // TODO move this to after POST to checkSession.php
    //                                 await axios.patch(
    //                                     `https://docuquest-swu.swucite.tech/api_drts/transactionsOverdue.php/${row.reference}`,
    //                                     {
    //                                         owner_lastname: row.owner_lastname,
    //                                         overdue_days: daysOverdue,
    //                                         staff: userIdRef.current,
    //                                         requestor_email: row.requestor_email,
    //                                         service: row.service,
    //                                         selected_docs: row.selected_docs,
    //                                         last_overdue_update: formatToSQLDateTime(getLocalDateTime()),
    //                                     }
    //                                 ).then((response) => {
    //                                     // console.log("Overdue update response:", response.data);


    //                                 }).catch((err) => {
    //                                     console.error("Error updating overdue days:", err.response?.data || err.message);
    //                                 });
    //                             } else {
    //                                 console.log("Overdue days already updated or no change needed.");
    //                             }
    //                         }
    //                     } else {
    //                         console.error("Release date not set!");
    //                     }
    
    //                     // console.log("Submitting status updates for reference:", row.reference);
    //                     // console.log("Submitting lastname to TransitStatus.php ", row.owner_lastname);
    //                     // console.log("Submitting updatedStatusTransit to TransitStatus.php ", updatedStatusTransit);

    //                     await Promise.all([
            
    //                         axios.patch(`https://docuquest-swu.swucite.tech/api_drts/transactionsResetOverdue.php/${row.reference}`, {
    //                             owner_lastname: row.owner_lastname,
    //                             overdue_days: row.overdue_days,
    //                         }).then((response) => {
    //                             // console.log("Transit status update response:", response.data);
    //                         }).catch((err) => {
    //                             console.error("Error updating overdue:", err.response?.data || err.message);
    //                         }),

    //                         axios.patch(`https://docuquest-swu.swucite.tech/api_drts/transactionsTransitStatus.php/${row.reference}`, {
    //                             owner_lastname: row.owner_lastname,
    //                             statusTransit: updatedStatusTransit,
    //                             staff: userIdRef.current,
    //                         }).then((response) => {
    //                             // console.log("Transit status update response:", response.data);
    //                         }).catch((err) => {
    //                             console.error("Error updating transit status:", err.response?.data || err.message);
    //                         }),
    
    //                         axios.patch(`https://docuquest-swu.swucite.tech/api_drts/transactionsPaymentStatus.php/${row.reference}`, {
    //                             owner_lastname: row.owner_lastname,
    //                             statusPayment: updatedStatusPayment,
    //                         }).then((response) => {
    //                             // console.log("Payment status update response:", response.data);
    //                         }).catch((err) => {
    //                             console.error("Error updating payment status:", err.response?.data || err.message);
    //                         }),
    //                     ]);
    //                 })
    //             );
    //         } catch (error) {
    //             console.error("Error updating overdue statuses:", error.message);
    //         }
    
    //         //console.log("Setting formatted data to state...");
    //         // console.warn("userIdRef.current is ", userIdRef.current);
    //         setDisplayData(formattedData);
    //         setLoading(false);
    //     })
    //     .catch((err) => {
    //         console.error(`ERROR fetching transaction #${refNumber}:`, err);
    //         setError(`Failed to fetch transaction details: ${err.message}`);
    //         setLoading(false);
    //     });
    // }, []);


    useEffect(() => {
        if (displayData.length === 0 || !userIdRef.current) {
            // console.warn("⚠️ Waiting for displayData or userIdRef...");
            return;
        }
    
        if (hasRunRef.current) {
            // console.warn("⏳ Skipping duplicate effect run (Strict Mode)");
            return;
        }
        hasRunRef.current = true; // Prevent duplicate execution
    
        const reference = displayData[0].reference;
    
        axios.get(`https://docuquest-swu.swucite.tech/api_drts/workflow.php?ref=${reference}`)
            .then((response) => {
                const existingEntry = response.data;
                // console.log("Existing entry response:", existingEntry);
                // console.warn("Existing entry data:", existingEntry.data);
    
                // console.warn("is existingEntry.data an array? " + Array.isArray(existingEntry.data));
                // console.warn("does existingEntry.data have data? " + existingEntry.data.length > 0);
                // console.warn("is existingEntry.data an array and has at least one entry? " + (Array.isArray(existingEntry.data) && existingEntry.data.length > 0));
                
                // console.warn("storedValues: ", existingEntry.data[0]);  
                // console.table(existingEntry.data[0]);

                if (Array.isArray(existingEntry.data) && existingEntry.data.length > 0) {
                    const storedValues = existingEntry.data[0];
                    // console.table(storedValues);
    
                    const lastUpdated = storedValues.updated_date ? new Date(storedValues.updated_date) : null;
                    const today = new Date();
                    const isUpdatedToday = lastUpdated && lastUpdated.toDateString() === today.toDateString();
    
                    // console.log("Last Updated:", lastUpdated ? lastUpdated.toISOString() : "No update date found");
                    // console.log("Today's Date:", today.toISOString());
                    // console.log("Is the entry updated today?", isUpdatedToday);
    
                    // Only create new row if `stage_now` is 0 and not updated today
                    if (!isUpdatedToday && storedValues.stage_now === 0) {  
                        const updatedStage = 1;
                        const updatedScoreProd = parseFloat(storedValues.score_prod) + 0.3;
    
                        // console.log(`🚀 Creating a NEW workflow entry: stage_now=${updatedStage}, score_prod=${updatedScoreProd}`);
    
                        axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                            updated_by: userIdRef.current,
                            updated_date: formatToSQLDateTime(today),
                            created_by: storedValues.created_by,
                            created_date: storedValues.created_date,
                            ref: reference,
                            name_action: "Review Request",
                            status_action: "Reviewing request details",
                            stage_now: updatedStage,
                            stage_max: storedValues.stage_max,
                            score_eff: parseFloat(storedValues.score_eff) + 0.5,
                            score_prod: updatedScoreProd,
                        })
                        .then(() => {
                            // console.log("✅ Updated new workflow entry created")
                        })
                        .catch(err => {
                            // console.error("❌ Error creating workflow entry:", err)
                        });
                    } else {
                        // console.log("⚠️ Workflow entry already updated today OR stage_now is not 0. Skipping new entry.");
                    }
                } else {
                    // console.log("🚀 No existing workflow entry found. Creating a new one.");
    
                    const workflow_post = {
                        created_by: userIdRef.current,
                        ref: reference,
                        name_action: "Initial Review",
                        status_action: "First review of request details",
                        stage_now: 0,
                        stage_max: 5,
                        score_eff: 0.0,
                        score_prod: 1.0,
                    };
                    // console.table(workflow_post);
    
                    axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, workflow_post)
                        .then(() => {
                            // console.log("✅ Brand new workflow entry created")
                        })
                        .catch(err => {
                            // console.error("❌ Error creating workflow entry:", err)
                        });
                }
            })
            .catch(err => {
                // console.error("❌ Error fetching workflow entry:", err)
            });
    }, [displayData]); 
    
    const statusOrder = [
        "Request Placed", "In Review", "Payment Sent", "Accepted", "Rejected", 
        "Processing", "Completed", "For Releasing", "Out for Delivery", 
        "Ready to Pick Up", "In Transit", "Received", "Claimed", "Delivered"
    ];

    const getButtonClass = (status) => {
        if (!displayData.length || !displayData[0]?.status_transit) {
            return "status-button disabled"; // Prevent errors if data isn't loaded
        }
    
        const currentStatus = displayData[0]?.status_transit;
        //console.log(`🔍 Current status: ${currentStatus}, Checking button: ${status}`);
    
        if (status === "Rejected" && !["Claimed", "Delivered", "Rejected"].includes(currentStatus)) {
            return "status-button enabled";
        }

        if (currentStatus === "Request Placed") {
            return (status === "Accepted" || status === "Rejected") ? "status-button enabled" : "status-button disabled";
        }
    
        if (currentStatus === "In Review") {
            return (status === "Accepted" || status === "Rejected") ? "status-button enabled" : "status-button disabled";
        }
    
        if (["Accepted", "Processing"].includes(currentStatus)) {
            return status === "Completed" ? "status-button enabled" : "status-button disabled";
        }
    
        if (currentStatus === "Rejected") {
            return status === "Accepted" ? "status-button enabled" : "status-button disabled";
        }
    
        if (currentStatus === "Completed") {
            return status === "For Releasing" ? "status-button enabled" : "status-button disabled";
        }
    
        if (["Ready to Pick Up", "For Releasing", "Out for Delivery"].includes(currentStatus)) {
            return (status === "Claimed" || status === "Delivered") ? "status-button enabled" : "status-button disabled";
        }
    
        return "status-button disabled"; // Default failsafe
    };
    
    
    
    const getRegionFee = (region) => {
        return axios
        .get(`https://docuquest-swu.swucite.tech/api_drts/shippingFee.php`, { params: { region } })
        .then((response) => {
          if (response.data.length > 0) {
            return response.data[0].fee; // Assuming response.data is an array
          } else {
            return "N/A"; // Handle no fee found
          }
        })
        .catch((error) => {
          //console.error(error);
          return "Error"; // Handle errors
        }); 
    }

    // triggers when displayData is updated
    // TODO this useeffect should run exactly once
    useEffect(() => {
        //  
        if (loading || error || displayData.length === 0) return;
        // hasDataRun.current = true;

        if (displayData.length > 0) {
            // console.log("request placed to in review: ", updatedStatusTransit);
            // console.warn("all data: ", displayData);
            // console.warn("first data: ", displayData[0]);
            // console.log("first receipt file", displayData[0].file_receipt);
            // console.log("REAL transit status: ", displayData[0]?.status_transit);
            // console.log("converted transit status: ", convertStatusTransit(displayData[0]?.status_transit));
            //console.warn("Current statusTransit:", displayData[0]?.statusTransit);
        
            //const currentStatusIndex = statusOrder.indexOf(displayData[0]?.statusTransit || "Request Placed");
            //console.warn("Computed currentStatusIndex:", currentStatusIndex, "for status:", displayData[0]?.statusTransit);

        }

        if (displayData[0]?.released_at) {
            const releasedAtDate = new Date(displayData[0].released_at);
            releasedAtDate.setHours(0, 0, 0, 0);

            const currentDate = new Date(formatToSQLDateTime(getLocalDateTime()));
            currentDate.setHours(0, 0, 0, 0);

            // Calculate days overdue based on difference
            const timeDiff = currentDate - releasedAtDate;
            const daysOverdue = Math.max(0, Math.floor(timeDiff / (1000 * 60 * 60 * 24)));

            if (daysOverdue > 0) {
                //console.log(`${displayData[0].reference} is ${daysOverdue} days overdue!`);
            
                const today = formatToSQLDateTime(getLocalDateTime()).split(" ")[0];
            
                axios
                    .get(`https://docuquest-swu.swucite.tech/api_drts/userNotifications.php/${userIdRef.current}`)
                    .then((res) => {
                        const notifications = Array.isArray(res.data) ? res.data : []; // Ensure it's an array
            
                        if (notifications.length === 0) {
                            //console.log("No previous notifications found. Sending first overdue notification...");
                            sendNotification("warning", `${displayData[0].reference} is ${daysOverdue} days overdue!`);
                            return;
                        }
            
                        const hasNotificationToday = notifications.some(
                            (notif) =>
                                notif.message.includes(`${displayData[0].reference} is ${daysOverdue} days overdue`) &&
                                notif.created_at.startsWith(today) // Checks if it was created today
                        );
            
                        if (!hasNotificationToday) {
                            //console.log("No overdue notification sent today. Sending notification...");
                            sendNotification("warning", `${displayData[0].reference} is ${daysOverdue} days overdue!`);
                        } else {
                            //console.log("Overdue notification already sent today. Skipping...");
                        }
                    })
                    .catch((err) => {
                        //console.error("Error checking existing notifications:", err);
                    });
            }
            
            // sendNotification("warning", `${displayData[0].reference} is ${daysOverdue} days overdue!`);
        }

        if (displayData[0]?.region) {
            setIsFeeLoading(true);
            getRegionFee(displayData[0].region).then((fee) => {
              setRegionFee(fee); // Set the fee once fetched
              setIsFeeLoading(false);
            });
        }

        return () => {
            //console.log("Cleanup function");
            // hasDataRun.current = false;
        }

    }, [loading]); // triggers when loading state changes

    useEffect(() => {
        if (displayData.length > 0 && displayData[0]?.statusTransit) {
            //console.warn("Current statusTransit:", displayData[0]?.statusTransit);
            const index = statusOrder.indexOf(displayData[0]?.statusTransit);
            //console.warn("Computed currentStatusIndex:", index, "for status:", displayData[0]?.statusTransit);
    
            if (index !== -1) {
                setCurrentStatusIndex(index);
            } else {
                //console.error(`Status '${displayData[0]?.statusTransit}' not found in statusOrder!`);
            }
        }
    }, [displayData]); // Runs whenever displayData updates
    
    useEffect(() => {
        //console.warn("🔥 useEffect for [loading, displayData] triggered. Loading:", loading);
        //console.warn("Updated displayData:", displayData);
    
        if (!loading && displayData.length > 0 && displayData[0]?.status_transit) { // FIXED
            //console.warn("🚀 Status Transit Found:", displayData[0]?.status_transit);
        
            const index = statusOrder.indexOf(displayData[0]?.status_transit); // FIXED
            //console.warn("📌 Computed currentStatusIndex:", index, "for status:", displayData[0]?.status_transit); // FIXED
        
            if (index !== -1) {
                setCurrentStatusIndex(index);
            } else {
                //console.error(`❌ Status '${displayData[0]?.status_transit}' not found in statusOrder!`);
            }
        } else {
            //console.warn("⚠️ `displayData` is still loading or empty.");
        }
    }, [loading, displayData]); // Runs when `loading` is false & `displayData` updates
    
    
    

    if (loading) return <p>Loading transaction details...</p>;
    if (error) return <p>{error}</p>;

    const formatDate = (timestamp) => {
        const date = new Date(timestamp); // Convert timestamp to Date object
        return date.toLocaleDateString('en-US', {
            month: 'short', // "Oct"
            day: 'numeric', // "6"
            year: 'numeric' // "2024"
        });
    };

    // TODO handle portrait picture


    // TODO refer to FormRequest
    // TODO change these to affect all items in the array displayData 
    const handleReceiptPictureChange = (e) => {
        const file = e.target.files[0];

        if (!file) {
            //console.error("No file selected");
            return;
        }
        
        setFile(file);
        
        const reader = new FileReader();

        reader.onloadend = () => {
            const base64String = reader.result;
    
            setDisplayReceipt(base64String); // Update the preview
            setDisplayData((prevData) =>
                prevData.map((item) => ({
                    ...item,
                    file_receipt: base64String, // Update each item with the new receipt
                }))
            );
        };
    
        reader.onerror = (err) => {
            //console.error("Error reading file:", err);
        };

        reader.readAsDataURL(file);
    };

    const handleDocumentPictureChange = (e) => {
        const file = e.target.files[0];
    
        if (!file) {
            //console.error("No file selected");
            return;
        }
    
        const reader = new FileReader();
    
        reader.onloadend = () => {
            const base64String = reader.result;
    
            setDisplayDocument(base64String); // Update the document preview
            setDisplayData((prevData) =>
                prevData.map((item) => ({
                    ...item,                                                                    
                    file_document: base64String, // Update the document for all items in displayData
                }))
            );
        };
    
        reader.onerror = (err) => {
            //console.error("Error reading file:", err);
        };
    
        reader.readAsDataURL(file);
    };

    const handleExceedChange = (e) => {
        const name = e.target.name;
        let value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
    
        // Enforce min/max values
        let numericValue = parseInt(value, 10);
        if (isNaN(numericValue)) {
            numericValue = 1; // Default to min if invalid
        } else {
            if (name === "exceed_pages") {
                numericValue = Math.min(Math.max(numericValue, 1), 99);
            } else if (name === "exceed_fee") {
                numericValue = Math.min(Math.max(numericValue, 1), 999);
            }
        }
    
        // update exceedParams
        setExceedParams((prevState) => {
            const newExceedParams = {
                ...prevState,
                [name]: numericValue,
                exceed_total: prevState.exceed_fee
                    ? displayData[0].total_price + numericValue
                    : displayData[0].total_price
            };
    
            //console.warn("Updated exceedParams:", newExceedParams);
            return newExceedParams;
        });
    };
    
    
    
    
    const handleContactChange = (e) => {
        const { name, value } = e.target;
        setContactParams({...contactParams, [name]: value})
    }

    const handleRejectChange = (e) => {
        const { name, value } = e.target;
        setRemarksData({...remarksData, [name]: value});
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setDisplayData({ ...displayData, [name]: value });
    };

    const handleExceedTotal = (e) => {
        e.preventDefault();

        //console.warn("exceedParams", exceedParams);
        
        if (!exceedParams.exceed_total || !displayData[0]?.owner_lastname) {
            //console.error("Missing required data for PATCH request.");
            return;
        }

        const exceedData = {
            exceed_fee: exceedParams.exceed_fee,
            exceed_total: exceedParams.exceed_total,
            // total_price: displayData[0].total_price,
            staff: userIdRef.current,
            reference: displayData[0].reference,
            owner_lastname: displayData[0].owner_lastname,
            owner_firstname: displayData[0].owner_firstname,
            requestor_email: displayData[0].requestor_email,
            service: displayData[0].service,
            region: displayData[0].region ? displayData[0].region : "",
            delivery_city: displayData[0].delivery_city ? displayData[0].delivery_city : "",
            delivery_district: displayData[0].delivery_district ? displayData[0].delivery_district : "",
            delivery_street: displayData[0].delivery_street ? displayData[0].delivery_street : "",
            selected_docs:  displayData[0].selected_docs, 
        }

        //console.warn("sending this exceedData: ", exceedData);
        axios.patch(`https://docuquest-swu.swucite.tech/api_drts/transactionsTotal.php/${displayData[0].reference}`, exceedData)
        .then((response) => {
            //console.log("PATCH Success:", response.data);
    
            if (response.data.status === 1) {
                // alert("Total price updated successfully!");
                
                // Update state to reflect new total price
                setDisplayData((prev) =>
                    prev.map((item) =>
                        item.reference === displayData[0].reference
                            ? { ...item, total_price: exceedParams.exceed_total }
                            : item
                    )
                );

                setExceedParams({
                    exceed_fee: '',   
                    exceed_pages: '',  
                    exceed_total : ''
                });
            } else {
                // alert("Failed to update total price. Please try again.");
                setExceedParams({
                    exceed_fee: '',   
                    exceed_pages: '',  
                    exceed_total : ''
                });
            }
        })
        .catch((error) => {
            //console.error("PATCH Failed:", error);
            // alert("An error occurred while updating the total price.");
            setExceedParams({
                exceed_fee: '',   
                exceed_pages: '',  
                exceed_total : ''
            });
        });
    }

    const handleTransitStatus = (status_transit) => async (e) => {
        e.preventDefault();

        try {
            const patchRequests = displayData.map((item) => {
                const patchData = {
                    staff: userIdRef.current,
                    owner_lastname: item.owner_lastname,
                    statusTransit: status_transit,
                };
    
                //console.warn("Patching data: ", patchData);
                //console.warn("currently patching: ", item);
                //console.log("sent staff id: ", patchData.staff);
                //console.log("sent reference: ", item.reference);
                //console.log("sent lastname: ", item.owner_lastname);
                //console.log("sent statusTransit: ", patchData.statusTransit);

                return axios.patch(
                    `https://docuquest-swu.swucite.tech/api_drts/transactionsTransitStatus.php/${item.reference}`, patchData, {
                        headers: { 'Content-Type': 'application/json' },
                    });
            });
    
            const responses = await Promise.all(patchRequests);
            //console.log("All patches completed:", responses);

            // TODO email requestor of transit status update
            

            // Update displayData with the new status
            setDisplayData((prev) =>
                prev.map((item) => ({
                    ...item,
                    status_transit, // Update each item with the new status
                }))
            );

            // return `Updated ${responses.length} rows to status: ${status_transit}`;
            return responses;
        } catch (err) {
            //console.error("Error submitting patches:", err);
        }
    }

    const handleRelease = async (e) => {
        e.preventDefault();

        if (!releaseDate) {
            alert("Please select a release date and time.");
            return;
        }

        try {
            const results = await handleTransitStatus("For Releasing")(e);
            //console.log("Release date set successful:", results.map((res) => res.data));

            const formattedReleaseDate = formatToSQLDateTime(releaseDate);
            
            const releaseData = {
                staff: userIdRef.current,
                total_price: displayData[0].total_price,
                owner_lastname: displayData[0].owner_lastname,
                owner_firstname: displayData[0].owner_firstname,
                requestor_email: displayData[0].requestor_email,
                service: displayData[0].service,
                region: displayData[0].region ? displayData[0].region : "",
                delivery_city: displayData[0].delivery_city ? displayData[0].delivery_city : "",
                delivery_district: displayData[0].delivery_district ? displayData[0].delivery_district : "",
                delivery_street: displayData[0].delivery_street ? displayData[0].delivery_street : "",
                selected_docs:  displayData[0].selected_docs, 
                release_date: formattedReleaseDate,
            };

            await axios.patch(
                `https://docuquest-swu.swucite.tech/api_drts/transactionsRelease.php/${refNumber}`, releaseData
            );
            
            //console.log("Release date successfully sent to the backend");

            setDisplayData((prev) =>
                prev.map((item) => ({
                    ...item,
                    released_at: releaseDate,
                    status_transit: "For Releasing", 
                }))
            );

            const releaseWorkflow = async () => {
                const reference = displayData[0].reference;

                try {
                    const response = await axios.get(`https://docuquest-swu.swucite.tech/api_drts/workflow.php?ref=${reference}`);
                    
                    const values = response.data.data[0];
                    
                    if (!values) {
                        //console.warn("No existing workflow entry found.");
                        return;
                    }
                    
                    const today = new Date();
            
                    await axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                        updated_by: userIdRef.current,
                        updated_date: formatToSQLDateTime(today),
                        created_by: values.created_by,
                        created_date: values.created_date,
                        due_date: formattedReleaseDate,
                        ref: reference,
                        feedback: `${reference} to release by ${formattedReleaseDate}`,
                        name_action: "Set Release Date",
                        status_action: "Setting release date for request",
                        stage_now: 4,
                        stage_max: values.stage_max,
                        score_eff: parseFloat(values.score_eff) + 0.5,
                        score_prod: parseFloat(values.score_prod) + 1.0,
                    });

                    // console.log("✅ Workflow row for release added.");
                } catch (err) {
                    // console.error("❌ Failed to create release workflow row:", err);
                }
            };
            
            await releaseWorkflow();

            setModalRelease(false);
            setRefreshing(true);
        } catch (err) {
            //console.error("Failed to set release date to transactions:", err);
        }
    }

    const handleContactCourier = (receiver, subject, body) => async (e) => {
        e.preventDefault();
    
        setModalContactCourier(false);
        // console.log("Submitting contact courier request...");
    
        try {
            const contactData = {
                selected_docs: displayData[0].selected_docs,
                total_price: displayData[0].total_price,
                requested_date: displayData[0].created_at,
                updated_date: displayData[0].updated_at,
                release_date: displayData[0].released_at,
                service: displayData[0].service,
                region: displayData[0].region,
                delivery_city: displayData[0].delivery_city,
                delivery_district: displayData[0].delivery_district,
                delivery_street: displayData[0].delivery_street,
                contact_email: receiver,
                contact_subject: subject,
                contact_body: body,
                name_staff: userNameRef.current,
                name_requestor: displayData[0].requestor_name,
                phone_requestor: displayData[0].requestor_phone,
                owner_firstname: displayData[0].owner_firstname,
                owner_middlename: displayData[0].owner_middlename ? displayData[0].owner_middlename : '',
                owner_lastname: displayData[0].owner_lastname,
            };
    
            // console.log("Sending request data:", contactData);
    
            const response = await axios.post(`https://docuquest-swu.swucite.tech/api_drts/transactionsContactCourier.php/${displayData[0].reference}`, contactData);
    
            //console.warn("Contact courier response:", response);
        } catch (err) {
            //console.error(`Cannot submit email to ${receiver}:`, err);
        }
    };
    

    const handleReject = (reason, remarks) => async (e) => {
        e.preventDefault();

        setModalReject(false);

        try {
            // Create rejection data for all items
            const rejectionPromises = displayData.map((item) => {
                const patchData = {
                    staff: userIdRef.current,
                    owner_lastname: item.owner_lastname,
                    statusTransit: "Rejected",
                };
                
                //console.warn("You are submitting rejection for:", patchData);
                //console.warn("currently rejecting: ", item);
                // console.log("sent staff id: ", patchData.staff);
                //console.log("sent reference: ", item.reference);
                //console.log("sent lastname: ", item.owner_lastname);
                //console.log("sent statusTransit: ", patchData.statusTransit);

                // Post rejection for each item
                return axios.patch(`https://docuquest-swu.swucite.tech/api_drts/transactionsTransitStatus.php/${item.reference}`, patchData, {
                    headers: { 'Content-Type': 'application/json' },
                });
            });

            const rejectWorkflow = () => {
                const reference = displayData[0].reference;
                
                return axios.get(`https://docuquest-swu.swucite.tech/api_drts/workflow.php?ref=${reference}`)
                .then((r) => {
                    const existingEntry = r.data;
                    const storedValues = existingEntry.data[0];

                    const today = new Date();

                    const updatedStage = 2;
                    const updatedScoreProd = parseFloat(storedValues.score_prod) + 0.8;
                    
                    return axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                        updated_by: userIdRef.current,
                        updated_date: formatToSQLDateTime(today),
                        created_by: storedValues.created_by,
                        created_date: storedValues.created_date,
                        ref: reference,
                        name_action: "Reject Request",
                        status_action: "Rejected document request",
                        stage_now: updatedStage,
                        stage_max: storedValues.stage_max,
                        score_eff: storedValues.score_eff,
                        score_prod: updatedScoreProd,
                    })
                    .then(() => {
                        // console.log("✅ New rejected workflow entry created")
                    })
                    .catch(err => {
                        // console.error("❌ Error creating workflow entry:", err)
                    });
                })
                .catch((err) => {

                })
            }

            const results = await Promise.all([
                ...rejectionPromises,
                rejectWorkflow()
            ]);
            // console.log("Rejections successful:", results.map((res) => res.data));

            const rejectData = {
                staff: userIdRef.current,
                owner_lastname: displayData[0].owner_lastname,
                owner_firstname: displayData[0].owner_firstname,
                
                requestor_email: displayData[0].requestor_email,
                reason: reason,
                remarks: remarks,
            };

            if (displayData[0].file_receipt && displayData[0].file_receipt.trim() !== "") {
                rejectData.receipt = displayData[0].file_receipt;
            }

            axios
            .post(`https://docuquest-swu.swucite.tech/api_drts/transactionsReject.php/${displayData[0].reference}`, rejectData)
            .then((res)=>{
                //console.warn(res.data)

            })
            .catch((err)=>{
                //console.warn("ERROR: cannot send request reject email:", err);
            })

            setDisplayData((prev) =>
                prev.map((item) => ({
                    ...item,
                    status_transit: "Rejected", // Update each item with the new status
                }))
            );

            setRefreshing(true);
        } catch (err) {
            //console.error("Failed to reject transactions:", err);
        }
    };

    const handleAccept = (status_transit) => async (e) => {
        e.preventDefault();

        const respondData = {
            staff: userIdRef.current,
            status_transit
        }

        try {
            // const updatedFileReceipt = file
            //     ? await new Promise((resolve, reject) => {
            //           const reader = new FileReader();
            //           reader.onload = () => resolve(reader.result.split(",")[1]); // Extract base64 portion
            //           reader.onerror = reject;
            //           reader.readAsDataURL(file); // Read the file as a base64 string
            //       })
            //     : displayData[0]?.file_receipt;
    
            const patchRequests = displayData.map((item) => {
                const patchData = {
                    ...item,
                    staff: userIdRef.current,
                    status_transit: "Processing",
                    // file_receipt: updatedFileReceipt,
                    owner_lastname: item.owner_lastname,
                };
    
                // console.warn("Patching data: ", patchData);
                // console.warn("currently accepting: ", item);
                // console.log("sent status_transit: ", patchData.status_transit);
                // console.log("sent reference: ", item.reference);
                // console.log("sent lastname: ", item.owner_lastname);

                return axios.patch(
                    `https://docuquest-swu.swucite.tech/api_drts/transactions.php/${item.reference}`,
                    patchData,
                    {
                        headers: { 'Content-Type': 'application/json' },
                    }
                );
            });
    
            const acceptWorkflow = () => {
                const reference = displayData[0].reference;

                return axios.get(`https://docuquest-swu.swucite.tech/api_drts/workflow.php?ref=${reference}`)
                .then((r) => {
                    const existingEntry = r.data;
                    const storedValues = existingEntry.data[0];

                    const today = new Date();

                    const updatedStage = 2;
                    const updatedScoreProd = parseFloat(storedValues.score_prod) + 1.0;

                    return axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                        updated_by: userIdRef.current,
                        updated_date: formatToSQLDateTime(today),
                        created_by: storedValues.created_by,
                        created_date: storedValues.created_date,
                        ref: reference,
                        name_action: "Accept Request",
                        status_action: "Accepted document request",
                        stage_now: updatedStage,
                        stage_max: storedValues.stage_max,
                        score_eff: storedValues.score_eff,
                        score_prod: updatedScoreProd,
                    })
                    .then(() => {
                        // console.log("✅ New accepted workflow entry created")
                    })
                    .catch(err => {
                        // console.error("❌ Error creating workflow entry:", err)
                    });
                })
                .catch((err) => {

                })
            }


            const responses = await Promise.all([
                ...patchRequests,
                acceptWorkflow()
            ]);
            //console.log("Accept successful:", responses);
            
            const acceptData = {
                ...respondData,
                reference: displayData[0].reference,
                total_price: displayData[0].total_price,
                owner_lastname: displayData[0].owner_lastname,
                owner_firstname: displayData[0].owner_firstname,
                requestor_email: displayData[0].requestor_email,
                service: displayData[0].service,
                region: displayData[0].region ? displayData[0].region : "",
                delivery_city: displayData[0].delivery_city ? displayData[0].delivery_city : "",
                delivery_district: displayData[0].delivery_district ? displayData[0].delivery_district : "",
                delivery_street: displayData[0].delivery_street ? displayData[0].delivery_street : "",
                selected_docs:  displayData[0].selected_docs, 
            };

            //console.log("email transit status: ", status_transit);

            // send acceptance email
            axios
            .post(`https://docuquest-swu.swucite.tech/api_drts/transactionsAccept.php/${displayData[0].reference}`, acceptData)
            .then((res)=>{
                //console.warn(res.data)

            })
            .catch((err)=>{
                //console.warn("ERROR: cannot send request accept email:", err);
            })

            // Update displayData with the new status
            setDisplayData((prev) =>
                prev.map((item) => ({
                    ...item,
                    status_transit, // Update each item with the new status
                }))
            );

            setRefreshing(true);
        } catch (err) {
            //console.error("Error submitting patches:", err);
        }
    }

    const sendNotification = (type, message) => {
        const postNotif = {
            user_id: userIdRef.current,
            type: type,
            message: message,
        }
        
        axios
        .post(`https://docuquest-swu.swucite.tech/api_drts/userNotifications.php`, postNotif)
        .then((res)=>{
          //console.warn("post notification response: ", res.data)
        })
        .catch((err)=>{
            //console.error(`ERROR: cannot send notification to ${postNotif.id_user}: ${err}`);
        })
    }

    // Ensure displayData is valid
    const displayItem = displayData[0] || { selected_docs: [] };

    // Calculate total price of selected documents (price * quantity)
    const totalDocsPrice = displayItem.selected_docs.reduce((acc, doc) =>
        acc + (parseFloat(doc.price || 0) * parseInt(doc.quantity || 0)), 0
    );

    // Ensure the region fee is a valid number
    const deliveryFee = parseFloat(regionFee) || 0;

    // Ensure the exceed fee is a valid number
    const exceedFee = isExceedOpen ? parseFloat(exceedParams?.exceed_fee || 0) : 0;

    // Compute the final totals
    const finalTotal = totalDocsPrice + deliveryFee;
    const finalTotalWithExceed = finalTotal + exceedFee;

    const refreshPage = () => {
        navigate(`/respond/${refNumber}`, {
            state: { lastname }
        });

        // window.location.reload();
    };

    return (
        <div className='body' id='respond'>
            <article className='.container-info-respond'>
              <form onSubmit={handleAccept} >
                
              <section id='main-data' className='data'>
                <h3 id='reference' className='header center'>{refNumber}</h3>

                <h5><em>{convertStatusTransit(displayData[0].status_transit)}</em></h5>

                <h5>
                {
                displayData[0]?.status_transit === "Accepted" 
                    ? `${displayData[0].status_payment}; ${convertStatusPayment(displayData[0].status_payment)}` 
                    : displayData[0]?.status_payment
                }
                </h5>
                
                <div className='body'>
                  <article className='form-readonly'>
                  {displayData[0]?.status_transit === "Rejected" && (
                        <div className='split-body'>
                            <table>
                              <thead>
                                <tr>
                                  <h5>Rejection Details</h5>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <th scope="row">Reason</th>
                                  <td>{displayData[0]?.reason_reject}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Remarks</th>
                                  <td>{displayData[0]?.remarks}</td>
                                </tr>
                              </tbody>
                            </table>
                        </div>
                    )
                    }
                    
                    <div className='split-body'>
                    {`Requested\u00A0on: `}<h5>{displayData[0].requested_at ? formatDate(displayData[0].requested_at) : "No requested on date"}</h5>

                    {`Released\u00A0on: `}<h5>{displayData[0].released_at ? formatDate(displayData[0].released_at) : "No release date"}</h5>
                    </div>

                    <div className='split-body'>  
                      <article className='form-readonly'>
                        {/* {displayData[0].service === "Delivery" ? (
                          <>
                           <button
                                id="contact-courier"
                                type='button'
                                onClick={() => {
                                  setContactParams({
                                    name_requestor: displayData[0].requestor_name,
                                    phone_requestor: displayData[0].requestor_phone,
                                    name_staff: userNameRef.current,
                                    // name_courier: '',
                                    selected_docs: displayData[0].selected_docs,
                                    total_price: displayData[0].total_price,
                                    region: displayData[0].region,
                                    delivery_city: displayData[0].delivery_city,
                                    delivery_district: displayData[0].delivery_district,
                                    delivery_street: displayData[0].delivery_street,
                                    contact_subject: '',
                                    contact_body: '',
                                    contact_email: '',
                                    // contact_name: '',
                                    // contact_phone: '',
                                    });
                                    
                                    setModalContactCourier(true); // Open the modal
                                }}
                                >
                                  Contact Courier
                                </button>

                                <Modal show={modalContactCourier}  onHide={() => setModalContactCourier(false)} centered >
                                    <Modal.Header>
                                        <article className="modal-close">
                                            <CloseButton onClick={() => setModalContactCourier(false)} title='Close' />
                                        </article>

                                        <Modal.Title>{`Contact courier for ${refNumber}`}</Modal.Title> 
                                    </Modal.Header>
                                    <Modal.Body>
                                      <form className='action-modal-form' onSubmit={(e) => handleContactCourier(contactParams.contact_email, contactParams.contact_subject, contactParams.contact_body)(e)}>
                                        <div className="label-modal-wrapper">
                                        <label htmlFor="contact_email">Courier E-mail</label>
                                        <input required placeholder='Enter email of courier' type='email' name='contact_email' value={contactParams.contact_email} onChange={handleContactChange}/>                                        
                                        </div>
                                        
                                        <div className="label-modal-wrapper">
                                        <label htmlFor="contact_subject">Subject</label>
                                        <input required placeholder='Enter subject' type='text' name='contact_subject' value={contactParams.contact_subject} onChange={handleContactChange}/>                                   
                                        </div>

                                        <div className="label-modal-wrapper">
                                        <label htmlFor="contact_body">Body</label>
                                        <textarea required placeholder='Enter a message for courier' name='contact_body' value={contactParams.contact_body} onChange={handleContactChange}>
                                            
                                        </textarea>
                                        </div>


     


                                      </form>
                                          
                                        <h5>Request&nbsp;Details</h5>
        
                                        {Array.isArray(displayData[0].selected_docs) && displayData[0].selected_docs.length > 0 ? (
                                            // TODO table class
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Document</th>
                                                        <th>Copies</th>
                                                        <th>Price</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {displayData[0].selected_docs.map((doc, idx) => (
                                                        <tr key={idx}>
                                                            <td>{doc.document || "N/A"}</td>
                                                            <td>{doc.quantity || 0}</td>
                                                            <td>{doc.price ? `₱${doc.price.toFixed(2)}` : "₱0.00"}</td>
                                                        </tr>
                                                    ))}

                                                    {displayData[0]?.region && (
                                                        <tr>
                                                            <td style={{ textAlign: "left" }}>Delivery&nbsp;region:&nbsp;</td>
                                                            <td>{displayData[0].region}</td>
                                                            <td>
                                                            {isFeeLoading ? "Loading..." : regionFee ? `₱${regionFee}` : "Error"}
                                                            </td>
                                                        </tr>
                                                    )}

                                                    <tr>
                                                        <td colSpan="2" style={{ fontWeight: "bold", textAlign: "center" }}>Total: </td>
                                                        <td style={{ fontWeight: "bold" }}>
                                                            {displayData[0].total_price ? `₱${displayData[0].total_price.toFixed(2)}` : "₱0.00"}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        ) : (
                                            <span>No documents selected</span>
                                        )}

                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="outline-secondary" title='Close and go back to request details.' onClick={() => setModalContactCourier(false)}>
                                          Cancel
                                        </Button> 
                                        <Button variant="dark" onClick={(e) => handleContactCourier(contactParams.contact_email, contactParams.contact_subject, contactParams.contact_body)(e)}>
                                          {`Ask for delivery update`} 
                                        </Button> 
                                    </Modal.Footer>
                                </Modal>
                          </>
                        ) : null
                        } */}

                        <Modal show={modalClaim} onHide={() => setModalClaim(false)} centered>
                            <Modal.Header>
                                <article className="modal-close">
                                    <CloseButton onClick={() => setModalClaim(false)} title='Close' />
                                </article>

                                <Modal.Title>Document Claim Details</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <form onSubmit={handleClaimSubmit}>
                                    <div className="form-group">
                                        <label htmlFor="receiver_name">Receiver's Full Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="receiver_name"
                                            name="receiver_name"
                                            value={claimData.receiver_name}
                                            onChange={handleClaimChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group mt-3">
                                        <label htmlFor="receive_date">Receive Date & Time</label>
                                        <input
                                            type="datetime-local"
                                            className="form-control"
                                            id="receive_date"
                                            name="receive_date"
                                            value={claimData.receive_date}
                                            onChange={handleClaimChange}
                                            min={currentDateTime}
                                            required
                                        />
                                    </div>
                                </form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setModalClaim(false)}>
                                    Cancel
                                </Button>
                                <Button variant="primary" onClick={handleClaimSubmit}>
                                    Confirm Claim
                                </Button>
                            </Modal.Footer>
                        </Modal>
                        
                        <div>
                          <label htmlFor="service">Service</label>
                          <input readOnly type="text" name="service" value={displayData[0].service} onChange={handleInputChange} />
                        </div>

                        <div>
                          <label htmlFor="purpose_req">Purpose</label>
                          {/* <input readOnly type="text" name="purpose_req" value={displayData[0].purpose} onChange={handleInputChange} /> */}
                          <textarea readOnly name="purpose_req" rows='8' cols='12' onChange={handleInputChange}>
                            {displayData[0].purpose}    
                          </textarea>
                        </div>

                        {displayData[0].description ? (
                        <div>
                          <label htmlFor="desc_req">Description</label>
                          <textarea readOnly name="desc_req" rows='4' cols='30' onChange={handleInputChange}>
                            {displayData[0].description}
                          </textarea>
                        </div>
                        ) : null
                        }      
                      </article>

                      {Array.isArray(displayData[0].selected_docs) && displayData[0].selected_docs.length > 0 ? (
                        // TODO class for table
                        <table>
                            <thead>
                                <tr>
                                    <th>Document</th>
                                    <th>Copies</th>
                                    <th>Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {displayData[0].selected_docs.map((doc, idx) => (
                                    <tr key={idx}>
                                        <td>{doc.document || "N/A"}</td>
                                        <td>{doc.quantity || 0}</td>
                                        <td>{doc.price ? `₱${doc.price.toFixed(2)}` : "₱0.00"}</td>
                                    </tr>
                                ))}

                                {displayData[0]?.region && (
                                <tr>
                                    <td style={{ textAlign: "left" }}>Delivery&nbsp;region:&nbsp;</td>
                                    <td>{displayData[0].region}</td>
                                    <td>
                                    {isFeeLoading ? "Loading..." : regionFee ? `₱${regionFee}` : "Error"}
                                    </td>
                                </tr>
                                )}

                                {/* <tr>
                                    <td colSpan="2" style={{ fontWeight: "bold", textAlign: "center" }}>Total: </td>
                                    <td style={{ fontWeight: "bold" }}>
                                    ₱{finalTotal.toFixed(2)}
                                    </td>
                                </tr> */}

                                <tr>
                                    <td colSpan="2" style={{ fontWeight: "bold", textAlign: "center" }}>Total: </td>
                                    <td style={{ fontWeight: "bold" }}>
                                        {displayData[0].total_price ? `₱${displayData[0].total_price.toFixed(2)}` : "₱0.00"}
                                        {/* ₱{finalTotalWithExceed.toFixed(2)} */}
                                    </td>
                                </tr>

                                {isExceedOpen === true && (
                                <>
                                  <tr>
                                    <td colSpan="2" style={{ textAlign: "center" }}>Total + Additional Fee: </td>
                                    <td >
                                    {displayData[0]?.total_price 
                                    ? `₱${(exceedParams.exceed_fee  
                                        ? (displayData[0].total_price + exceedParams.exceed_fee).toFixed(2) 
                                        : displayData[0].total_price.toFixed(2))}`
                                    : "₱0.00"}
                                    {/* ₱{finalTotalWithExceed.toFixed(2)} */}
                                    </td>
                                  </tr>    
                                </>
                                )
                                }  
                            </tbody>
                        </table>
                      ) : (
                        <span>No documents selected</span>
                      )}
                    </div>

                    <label htmlFor='check_exceed'>Document exceeds standard page number?</label>
                    <input 
                    type='checkbox' 
                    name='check_exceed'
                    checked={isExceedOpen} 
                    // TODO 100 in "* 100" should be a react state
                    onChange={() => {
                      setIsExceedOpen((prev) => !prev);
                      setExceedParams((prevState) => ({
                        ...prevState,
                        exceed_pages: prevState.exceed_pages || 1, // Default to 1 if empty
                        exceed_fee: (prevState.exceed_pages || 1) * 100, // Calculate initial exceed fee
                        exceed_total:
                        (displayData[0].total_price || 0) +
                        (prevState.exceed_pages || 1) * 100, // Update total
                      }));
                    }}
                    />
                    {isExceedOpen === true && (
                      <>
                        <form onSubmit={handleExceedTotal}>
                        <label htmlFor="exceed_pages">Exceeding Pages:</label>
                        <input 
                            required 
                            type="number" 
                            name="exceed_pages" 
                            placeholder="Enter number of exceeding pages" 
                            value={exceedParams.exceed_pages}
                            min={1} 
                            max={99} 
                            onChange={(e) => {
                                const pages = parseInt(e.target.value, 10) || 1;
                                const fee = pages * 100;
                                setExceedParams({
                                  exceed_pages: pages,
                                  exceed_fee: fee,
                                  exceed_total:
                                    (displayData[0].total_price || 0) + fee,
                                });
                            }}
                        />

                        <label htmlFor="exceed_fee">Exceeding Fee:</label>
                        <h5>₱{exceedParams.exceed_fee}</h5>{" "}
                        {/* (exceedParams.exceed_fee || 0).toFixed(2) */}
                        {/* Show calculated fee */}

                        <label>Total Price (Including Exceeding Fee):</label>
                        <h5>₱{exceedParams.exceed_total}</h5>{" "}
                        {/* (parseFloat(displayData[0]?.total_price || 0) + (exceedParams.exceed_fee || 0)).toFixed(2) */}
                        {/* Show updated total price */}

                        {/* <input 
                            required 
                            type="number" 
                            name="exceed_fee" 
                            placeholder="Enter exceeding pages fee"
                            value={exceedParams.exceed_fee} 
                            min={1} 
                            max={999} 
                            onChange={handleExceedChange} 
                        /> */}


                            <Button variant='danger' type="button" onClick={handleExceedTotal}>Update Total Price</Button>
                        </form>
                      </>
                    )
                    }

                  </article>
                </div>
              </section>

              <section className='data'>
  <h5 className='header'>Requestor & Owner</h5>
  <div className='body'>
    <div className='split-body'>
      <article className='form-readonly'>
        <div className="d-flex justify-content-between align-items-center">
            <h5>Requestor</h5>
            {/* TODO only edit if transit status is In Review or Rejected */}
            {/* {!isEditing ? (
                <Button variant="outline-primary" size="sm" onClick={() => setIsEditing(true)}>
                Edit Request
                </Button>
            ) : (
                <div>
                <Button variant="outline-success" size="sm" onClick={handleSaveEdits} className="me-2">
                    Save Changes
                </Button>
                <Button variant="outline-danger" size="sm" onClick={() => setIsEditing(false)}>
                    Cancel
                </Button>
                </div>
            )} */}
        </div>

        <div>
          <label htmlFor="name_req">Name</label>
          {isEditing ? (
            <input type="text" name="requestor_name" value={editData.requestor_name} onChange={handleEditChange} />
          ) : (
            <input readOnly type="text" name="requestor_name" value={displayData[0].requestor_name} />
          )}
        </div>

        <div>
          <label htmlFor="phone_req">Phone</label>
          {isEditing ? (
            <input type="text" name="requestor_phone" value={editData.requestor_phone} onChange={handleEditChange} />
          ) : (
            <input readOnly type="text" name="requestor_phone" value={displayData[0].requestor_phone} />
          )}
        </div>
        
        <div>
          <label htmlFor="email_req">Email</label>
          {isEditing ? (
            <input type="email" name="requestor_email" value={editData.requestor_email} onChange={handleEditChange} />
          ) : (
            <input readOnly type="email" name="requestor_email" value={displayData[0].requestor_email} />
          )}
        </div>

        {displayData.length > 0 && displayData[0].service === "Delivery" ? (
        <div>
            {isEditing ? (
            // show if isEditing is true
            <>
                <label htmlFor="delivery_region">Region</label>
                <input
                type="text"
                name="delivery_region"
                value={editData.delivery_region}
                onChange={handleEditChange}
                />

                <label htmlFor="delivery_city">City</label>
                <input
                type="text"
                name="delivery_city"
                value={editData.delivery_city}
                onChange={handleEditChange}
                />

                <label htmlFor="delivery_district">District</label>
                <input
                type="text"
                name="delivery_district"
                value={editData.delivery_district}
                onChange={handleEditChange}
                />

                <label htmlFor="delivery_street">Street</label>
                <input
                type="text"
                name="delivery_street"
                value={editData.delivery_street}
                onChange={handleEditChange}
                />
            </>
            ) : (
            // show if isEditing is false
            <>
                <label htmlFor="delivery_region">Region</label>
                <input
                readOnly
                type="text"
                name="delivery_region"
                value={displayData[0].region}
                />

                <label htmlFor="address_req">Address</label>
                <textarea
                readOnly
                name="address_req"
                rows="6"
                cols="30"
                >
                {displayData[0].requestor_address}
                </textarea>
            </>
            )}
        </div>
        ) : null}


        {/* Add Claim Information section if the document has been claimed */}
        {displayData[0]?.status_transit === "Claimed" && (
  <div className="claim-info">
    <h5>Claim Information</h5>
    <div className="form-group">
      <label>Received by</label>
      <input 
        readOnly 
        type="text" 
        value={displayData[0].receiver_name || "Not specified"} 
      />
    </div>
    <div className="form-group">
      <label>Received on</label>
      <input 
        readOnly 
        type="text" 
        value={displayData[0].receive_date 
          ? new Date(displayData[0].receive_date).toLocaleString() 
          : "Not specified"
        } 
      />
    </div>
    <div className="form-group">
      <label>Processed by</label>
      <input 
        readOnly 
        type="text" 
        value={displayData[0].claimed_by || "Not specified"} 
      />
    </div>
  </div>
)}
      </article>

      <article className='form-readonly'>
        <h5>Owner</h5>
        <div>
          <label htmlFor="id_swu">Student ID</label>
          {isEditing ? (
            <input type="text" name="owner_SWU" value={editData.owner_SWU} onChange={handleEditChange} />
          ) : (
            <input readOnly type="text" name="owner_SWU" value={displayData[0].owner_SWU} />
          )}
        </div>

        <div>
          <label htmlFor="name_last">Last name</label>
          {isEditing ? (
            <input type="text" name="owner_lastname" value={editData.owner_lastname} onChange={handleEditChange} />
          ) : (
            <input readOnly type="text" name="owner_lastname" value={displayData[0].owner_lastname} />
          )}
        </div>

        <div>
          <label htmlFor="name_first">First name</label>
          {isEditing ? (
            <input type="text" name="owner_firstname" value={editData.owner_firstname} onChange={handleEditChange} />
          ) : (
            <input readOnly type="text" name="owner_firstname" value={displayData[0].owner_firstname} />
          )}
        </div>

        <div>
          <label htmlFor="name_middle">Middle name</label>
          {isEditing ? (
            <input type="text" name="owner_middlename" value={editData.owner_middlename} onChange={handleEditChange} />
          ) : (
            <input readOnly type="text" name="owner_middlename" value={displayData[0].owner_middlename} />
          )}
        </div>

        <div>
          <label htmlFor="phone_owner">Phone</label>
          {isEditing ? (
            <input type="text" name="owner_phone" value={editData.owner_phone} onChange={handleEditChange} />
          ) : (
            <input readOnly type="text" name="owner_phone" value={displayData[0].owner_phone} />
          )}
        </div>
        
        <div>
          <label htmlFor="course">Course</label>
          {isEditing ? (
            <input type="text" name="owner_course" value={editData.owner_course} onChange={handleEditChange} />
          ) : (
            <input readOnly type="text" name="owner_course" value={displayData[0].owner_course} />
          )}
        </div>

        <div>
          <label htmlFor="course">Year enrolled</label>
          {isEditing ? (
            <input type="text" name="owner_course_year" value={editData.owner_course_year} onChange={handleEditChange} />
          ) : (
            <input readOnly type="text" name="owner_course_year" value={displayData[0].owner_course_year} />
          )}
        </div>

        <div>
          <label htmlFor="course">Last year in SWU</label>
          {isEditing ? (
            <input type="text" name="owner_year_last" value={editData.owner_year_last} onChange={handleEditChange} />
          ) : (
            <input readOnly type="text" name="owner_year_last" value={displayData[0].owner_year_last} />
          )}
        </div>
      </article>  
    </div>
  </div>
</section>

              <section className='data'>
                <h5 className='header'>Actions</h5>
                <div className='body'>
                  <article className='form-readonly'>
                    <h5>Attachments</h5>

                        {displayData[0].file_portrait ? (
                            <div>
                            <h5>Portrait</h5>
                            <img 
                                src={displayData[0].file_portrait}
                                alt='2x2&nbsp;portrait'
                                title={`portrait of ${displayData[0].owner_lastname}, ${displayData[0].owner_firstname} ${displayData[0].owner_middlename}`}
                                className='view-portrait'
                            />        
                            </div>
                        ) : (
                            <div>
                                <p>No portrait found!</p>
                            </div>
                        )
                        }
                        
                        {loading ? (
                        <p>Loading supporting document…</p>
                        ) : docViewerDocuments.length > 0 ? (
                        <div style={{ height: '75vh', overflowY: 'auto' }}>
                            <DocViewer
                            documents={docViewerDocuments}
                            pluginRenderers={DocViewerRenderers}
                            style={{ width: '100%', height: '100%' }}
                            />
                        </div>
                        ) : (
                        <p>No supporting document provided.</p>
                        )}

                        {displayData[0].payment_channel ? (
                            <div>
                            <h5>Payment Method</h5>
                            {displayData[0].payment_channel}
                            </div>
                        ) : null
                        }

                        {displayData[0].file_receipt ? (
                            <div>
                            <h5>Receipt</h5>
                            <article className='inspect-group'>
                                <img
                                src={displayData[0].file_receipt}
                                alt="Receipt"
                                title={`attached receipt of ${refNumber}`}
                                style={{ width: "300px", height: "auto", cursor: "pointer" }}
                                onClick={() => setModalReceipt(true)}
                                />

                                <Button id='inspect-receipt' variant='warning' size='sm' type='button' onClick={() => setModalReceipt(true)}>Inspect receipt</Button>
                            </article>
                            </div>
                        ) : (
                            <div>
                              <h5>{convertStatusPayment(displayData[0].status_payment)}</h5>
                              <p>No receipt found!</p>
                            </div>
                        )}
                        
                        <Modal show={modalReceipt} onHide={() => setModalReceipt(false)} size="lg" centered>
                            <Modal.Header>
                                <article className="modal-close">    
                                    <CloseButton onClick={() => setModalReceipt(false)} title='Close'/>
                                </article>
                                
                                <Modal.Title>Inspect Receipt</Modal.Title>
                            </Modal.Header>
                            <Modal.Body
                                style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                overflow: "hidden",
                                }}
                            >
                                <TransformWrapper initialScale={1} minScale={0.5} maxScale={3}>
                                {({ zoomIn, zoomOut, resetTransform }) => (
                                    <div>
                              
                                    <div style={{ textAlign: "center", marginBottom: "10px" }}>
                                        <Button variant="outline-secondary" onClick={() => zoomIn()} style={{ margin: "0 5px" }}>
                                          Zoom In
                                        </Button>
                                        <Button variant="outline-secondary" onClick={() => zoomOut()} style={{ margin: "0 5px" }}>
                                          Zoom Out
                                        </Button>
                                        <Button variant="outline-secondary" onClick={() => resetTransform()} style={{ margin: "0 5px" }}>
                                          Reset
                                        </Button>
                                    </div>
                                    
                                    {/* Image Viewer */}
                                    <TransformComponent
                                      wrapperStyle={{
                                        maxWidth: "100%",
                                        maxHeight: "80vh",
                                        cursor: "grab",
                                      }}
                                    >
                                        <img
                                        id="inspect-receipt"
                                        src={displayData[0].file_receipt}
                                        alt="Receipt"
                                        title={`attached receipt of ${refNumber}`}
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: "100%",
                                        }}
                                        />
                                    </TransformComponent>
                                    </div>
                                )}
                                </TransformWrapper>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setModalReceipt(false)}>
                                Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                        
                        <div>
                            {/* {displayDocument && (
                            <div>
                                <img 
                                src={displayDocument}
                                alt='document'
                                title={`${displayData[0].doc_title}`}
                                className=''
                                />
                            </div>
                            )}                    
                            <br/> */}

                            <h5>Actions</h5>

                            {isActionsOpen && (
                            // TODO classname for div
                            // style={{ position: 'fixed' }}
                            <div >
                                <button id="accept" className={getButtonClass("Accepted")} type="button"
                                    disabled={getButtonClass("Accepted") === "status-button disabled"}
                                    onClick={() =>
                                        showConfirm({
                                            title: "Confirm Accepted",
                                            message: `Are you sure you want to mark ${refNumber} as Accepted?`,
                                            action: (e) => handleAccept('Processing')(e),
                                        })
                                    }
                                >
                                    Accept
                                </button>
                                
                                <button id='reject' className={getButtonClass("Rejected")} type='button'
                                    disabled={getButtonClass("Rejected") === "status-button disabled"} 
                                    onClick={() => setModalReject(true)}
                                >
                                    Reject
                                </button>

                                <Modal show={modalReject} onHide={() => setModalReject(false)} size='lg' centered>
                                    <Modal.Header>
                                        <article className="modal-close">
                                            <CloseButton onClick={() => setModalReject(false)} title='Close'/>
                                        </article>

                                        <Modal.Title>Reject Transaction</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                    {displayData[0].file_receipt && displayData[0].file_receipt.trim() !== "" && (
                                        <img
                                            id="inspect-receipt"
                                            src={displayData[0].file_receipt}
                                            alt="Receipt"
                                            title={`attached receipt of ${refNumber}`}
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                            }}
                                        />
                                    )}

                                        <p>Enter the reason and remarks why you are rejecting this request.</p>
                                        <div>

                                        <form className='action-modal-form' onSubmit={(e) => handleReject(remarksData.reason, remarksData.remarks)(e)}>
                                          <div className='label-modal-wrapper'>
                                            <label htmlFor="reason">Reason</label>
                                            <input required placeholder='Enter reason for rejecting' type='text' name='reason' value={remarksData.reason} onChange={handleRejectChange}/>                                            
                                          </div>

                                          <div className='label-modal-wrapper'>
                                            <label htmlFor="remarks">Remarks</label>
                                            <textarea required placeholder='Enter remarks or comments for rejecting' name='remarks' value={remarksData.remarks} onChange={handleRejectChange}>
                                            </textarea>                                            
                                          </div>

                                          <>
                                          <Button variant="warning" type='submit' onClick={(e) => handleReject(remarksData.reason, remarksData.remarks)(e)} title='Reject request'>
                                          {`Reject ${refNumber}`}
                                          </Button>
                                          </>

                                         </form>

                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="outline-secondary" onClick={() => setModalReject(false)} title='Close and go back to request details.'>
                                        Cancel
                                        </Button> 
                                    </Modal.Footer>
                                </Modal>
                                
                                <button id='completed' className={getButtonClass("Completed")} type='button'
                                    disabled={getButtonClass("Completed") === "status-button disabled"}
                                    onClick={() => 
                                        showConfirm({
                                            title: "Confirm Completion",
                                            message: `Are you sure you want to mark ${refNumber} as completed?`,
                                            action: (e) => {
                                                handleTransitStatus("Completed")(e)
                                                
                                                // new request complete row in workflow table
                                                axios.get(`https://docuquest-swu.swucite.tech/api_drts/workflow.php?ref=${displayData[0].reference}`)
                                                .then((r) => {
                                                    const existingEntry = r.data;
                                                    const storedValues = existingEntry.data[0];
                                
                                                    const today = new Date();
                                
                                                    const updatedStage = 3;
                                                    const updatedScoreProd = parseFloat(storedValues.score_prod) + 1.2;

                                                    axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                                                        updated_by: userIdRef.current,
                                                        updated_date: formatToSQLDateTime(today),
                                                        created_by: storedValues.created_by,
                                                        created_date: storedValues.created_date,
                                                        ref: displayData[0].reference,
                                                        name_action: "Complete Request",
                                                        status_action: "Completed document request",
                                                        stage_now: updatedStage,
                                                        stage_max: storedValues.stage_max,
                                                        score_eff: storedValues.score_eff,
                                                        score_prod: updatedScoreProd,
                                                    })
                                                    .then(() => {

                                                    })
                                                    .catch((err) => {

                                                    })

                                                })
                                                .catch((err)=>{

                                                })

                                                setRefreshing(true);
                                            },
                                        })
                                    }>
                                    Complete
                                </button>

                                <Modal show={modalConfirm} onHide={handleCancel} centered>
                                    <Modal.Header>
                                        <article className="modal-close">
                                            <CloseButton onClick={handleCancel} title='Close'/>
                                        </article>

                                        <Modal.Title>{confirmParams.title || "Are you sure?"}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {confirmParams.message || "Are you sure you want do this?"}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="outline-secondary" onClick={handleCancel} title='Close and go back to request details.'>
                                            Cancel
                                        </Button>
                                        <Button variant="success" onClick={handleConfirm}>
                                            Confirm
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                                

                                <button id='releasing' className={getButtonClass("For Releasing")} disabled={getButtonClass("For Releasing") === "status-button disabled"} type='button' onClick={() => setModalRelease(true)}>For Releasing</button>

                                <Modal show={modalRelease} onHide={() => setModalRelease(false)} centered>
                                <Modal.Header>
                                    <article className="modal-close">
                                        <CloseButton onClick={() => setModalRelease(false)} title='Close' />
                                    </article>
                                    {/* ${refNumber} */}
                                    <Modal.Title>{`Release Document`}</Modal.Title>           
                                </Modal.Header>
                                <Modal.Body>
                                    <p>Set release date for {`${refNumber}`}.</p>
                                    <label htmlFor="release_date">Release Date & Time:</label>
                                    <input
                                        required
                                        type="datetime-local"
                                        name="release_date" // TODO css class
                                        placeholder={currentDateTime}
                                        value={releaseDate}
                                        min={currentDateTime} // commented out for testing
                                        onChange={(e) => setReleaseDate(e.target.value)}  
                                        style={{ display: 'block', marginTop: '10px' }}
                                    />      

                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="outline-secondary" title='Close and go back to request details.' onClick={() => setModalRelease(false)}>
                                    Cancel
                                    </Button> 
                                    <Button variant="success" onClick={handleRelease}>
                                    Release
                                    </Button> 
                                </Modal.Footer>
                                </Modal>
                                
                                <Modal show={modalDeliver} onHide={() => setModalDeliver(false)} centered>
                                <Modal.Header>
                                    <article className="modal-close">
                                        <CloseButton onClick={() => setModalDeliver(false)} title='Close' />
                                    </article>

                                    <Modal.Title>Delivery Details</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <form className='action-modal-form' onSubmit={handleDeliverSubmit}>
                                    <div className="label-modal-wrapper">
                                        <label htmlFor="receiver_name">Receiver's Full Name</label>
                                        <input
                                        type="text"
                                        className="form-control"
                                        id="receiver_name"
                                        name="receiver_name"
                                        value={deliverData.receiver_name}
                                        onChange={handleDeliverChange}
                                        required
                                        />
                                    </div>
                                    <div className="label-modal-wrapper">
                                        <label htmlFor="receive_date">Delivery Date & Time</label>
                                        <input
                                        type="datetime-local"
                                        className="form-control"
                                        id="receive_date"
                                        name="receive_date"
                                        value={deliverData.receive_date}
                                        onChange={handleDeliverChange}
                                        min={currentDateTime}
                                        required
                                        />
                                    </div>
                                    </form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setModalDeliver(false)}>
                                    Cancel
                                    </Button>
                                    <Button variant="primary" onClick={handleDeliverSubmit}>
                                    Confirm Delivery
                                    </Button>
                                </Modal.Footer>
                                </Modal>

                                {displayData[0].service === "Delivery" ? (
                                    <div>
                                      <button id="delivered" type="button"
                                        className={getButtonClass("Delivered")}
                                        disabled={getButtonClass("Delivered") === "status-button disabled"}
                                        onClick={() => {
                                            // showConfirm({
                                            //     title: "Confirm Delivered",
                                            //     message: `Are you sure you want to mark ${refNumber} as Delivered?`,
                                            //     action: (e) => handleTransitStatus("Delivered")(e),
                                            // })
                                            setDeliverData({
                                               receiver_name: '',
                                               receive_date: getLocalDateTime()
                                            });
                                            setModalDeliver(true);   
                                        }}
                                      >
                                        Deliver
                                      </button>
                                      
                                     
                                    </div>
                                ) : (
                                    <div>
                                      {/* Replace your current Claim button with this FOLLOW THIS HANS*/}
                                      <button 
                                            id="claimed" 
                                            type="button"
                                            className={getButtonClass("Claimed")}
                                            disabled={getButtonClass("Claimed") === "status-button disabled"}
                                            onClick={() => {
                                                setClaimData({
                                                    receiver_name: '',
                                                    receive_date: getLocalDateTime()
                                                });
                                                setModalClaim(true);
                                            }}
                                      >
                                        Claim
                                      </button>

                                    </div>
                                )
                                }
                            </div>
                            )}
                            
                            <div className='split-actions'>
                              <Button id='back' variant="outline-dark" onClick={() => navigate('/overview/transactions/')}>
                                Go Back
                              </Button>

                              <Button id='refresh' variant="secondary" onClick={() => setRefreshing(prev => !prev)}>
                                Refresh
                              </Button>

                              <button className="save-button" type="button" onClick={toggleActions}>
                                Respond to this Request
                              </button>
                            </div>
                        </div>

                  </article>    
                </div>
              </section>

              </form>
            </article>
        </div>
    )    
}